import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Table } from 'antd'
import PropTypes from 'prop-types'

import { useDishIngredientsDrawerHotkeyHighlights } from '../../hooks'

import DishIngredientsDrawerIngredient from './dish-ingredients-drawer-ingredient'
import DishIngredientsDrawerMenuText from './dish-ingredients-drawer-menu-text'

const DishIngredientsDrawerTable = ({
  data,
  fieldName,
  dishId,
  isDisabled,
}) => {
  useDishIngredientsDrawerHotkeyHighlights()
  const { selectedRowKey } = useSelector(
    store => store.dishes.dishes.drawerHotkeys,
  )

  const { areMlIngredientsEnabled } = useSelector(store => store.aiSettings)

  const columns = useMemo(
    () => [
      {
        title: 'Menu text',
        dataIndex: 'menuText',
        key: 'menuText',
        render: (
          _,
          {
            menuText,
            highlight,
            isSuggestedUsingMl,
            isSuggestedUsingParser,
            mlScore,
          },
        ) => (
          <DishIngredientsDrawerMenuText
            menuText={menuText}
            highlight={highlight}
            isSuggestedUsingParser={isSuggestedUsingParser}
            isSuggestedUsingMl={isSuggestedUsingMl}
            mlScore={mlScore}
          />
        ),
      },
      {
        title: 'Ingredient',
        dataIndex: 'name',
        key: 'name',
        render: (
          _,
          {
            name,
            highlight,
            isDiscrepancyAccepted,
            isSuggestedUsingMl,
            isSuggestedUsingParser,
            id,
          },
        ) => (
          <DishIngredientsDrawerIngredient
            id={id}
            name={name}
            dishId={dishId}
            fieldName={fieldName}
            highlight={highlight}
            isDiscrepancyAccepted={isDiscrepancyAccepted}
            isSuggestedUsingMl={isSuggestedUsingMl}
            isSuggestedUsingParser={isSuggestedUsingParser}
            isCheckboxDisabled={isDisabled}
            isCheckboxVisible={areMlIngredientsEnabled}
            isSelected={id === selectedRowKey}
          />
        ),
      },
    ],
    [areMlIngredientsEnabled, dishId, fieldName, isDisabled, selectedRowKey],
  )

  return (
    <Table
      rowKey="id"
      className="dish-drawer-table"
      dataSource={data}
      columns={columns}
      size="small"
      pagination={false}
    />
  )
}

DishIngredientsDrawerTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  fieldName: PropTypes.string.isRequired,
  dishId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
}

DishIngredientsDrawerTable.defaultProps = {
  data: [],
  isDisabled: false,
}

export default DishIngredientsDrawerTable
